/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import { sponsorAPI } from '../services/api';

const EditSponsor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { sponsors, updateSponsor, deleteSponsor } = useContent();

  const [sponsor, setSponsor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    category: 'platinum',
    description: '',
    website: '',
    image: null,
    imageUrl: '',
    removeImage: false
  });

  useEffect(() => {
    let mounted = true;

    const setFromSponsor = (found) => {
      setSponsor(found);
      setFormData({
        name: found.name || '',
        category: found.category || 'platinum',
        description: found.description || '',
        website: found.website || '',
        image: null,
        imageUrl: found.logo_url || found.imageUrl || '',
        removeImage: false
      });
    };

    const found = sponsors.find(s => String(s.id) === String(id));
    if (found) {
      setFromSponsor(found);
      setLoading(false);
    } else {
      // try to fetch sponsor from API as fallback
      sponsorAPI.getSponsor(id).then(res => {
        if (!mounted) return;
        if (res && res.success && res.data) {
          setFromSponsor(res.data);
        }
      }).catch(err => {
        console.error('Failed to fetch sponsor:', err);
      }).finally(() => mounted && setLoading(false));
    }

    return () => { mounted = false };
  }, [id, sponsors]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, image: file, imageUrl: URL.createObjectURL(file), removeImage: false }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sponsor) return;

    const payload = { ...formData };
    if (payload.removeImage) payload.remove_image = true;

    try {
      await updateSponsor(sponsor.id, payload);
      navigate('/admin/sponsors');
    } catch (err) {
      console.error('Update failed', err);
    }
  };

  const handleDelete = async () => {
    if (!sponsor) return;
    if (!window.confirm('Delete this sponsor?')) return;
    try {
      await deleteSponsor(sponsor.id);
      navigate('/admin/sponsors');
    } catch (err) {
      console.error('Delete failed', err);
    }
  };

  if (!sponsor) {
    return (
      <div style={{ padding: 20 }}>
        <h3>Sponsor not found</h3>
        <button onClick={() => navigate('/admin/sponsors')} className="btn">Back</button>
      </div>
    );
  }

  return (
    <div className="edit-sponsor" style={{ padding: 20 }}>
      <h2>Edit Sponsor</h2>
      <form onSubmit={handleSubmit} className="sponsor-form">
        <div className="form-group">
          <label>Name</label>
          <input value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
        </div>

        <div className="form-group">
          <label>Category</label>
          <select value={formData.category} onChange={(e) => setFormData({...formData, category: e.target.value})}>
            <option value="platinum">Platinum</option>
            <option value="gold">Gold</option>
            <option value="silver">Silver</option>
          </select>
        </div>

        <div className="form-group">
          <label>Website</label>
          <input type="url" value={formData.website} onChange={(e) => setFormData({...formData, website: e.target.value})} />
        </div>

        <div className="form-group">
          <label>Description</label>
          <textarea value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})} rows={4} />
        </div>

        <div className="form-group">
          <label>Logo</label>
          <div>
            {formData.imageUrl ? <img src={formData.imageUrl} alt="preview" style={{ maxWidth: 180 }} /> : <div style={{ padding: 12 }}>No image</div>}
          </div>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          <div style={{ marginTop: 8 }}>
            <label>
              <input type="checkbox" checked={formData.removeImage} onChange={(e) => setFormData({...formData, removeImage: e.target.checked})} /> Remove existing image
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/sponsors')}>Cancel</button>
          <button type="submit" className="btn btn-primary">Save</button>
          <button type="button" className="btn btn-danger" onClick={handleDelete} style={{ marginLeft: 8 }}>Delete</button>
        </div>
      </form>
    </div>
  );
};

export default EditSponsor;
